import { Component } from '@angular/core';
import { ConnectionService } from '../connection.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-inner-footer',
  templateUrl: './inner-footer.component.html',
  styleUrls: ['./inner-footer.component.css']
})
export class InnerFooterComponent {
  siteDetails: any;
  cmsList: any;

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute) { }

  ngOnInit() {
    this.getSettings();
    this.getCms()
  }
  getSettings() {
    this.conn.getUrl('admin/settings').subscribe((res: any) => {
      if (res.status == true) {
        this.siteDetails = res.data
      }
    })
  }

  getCms() {
    this.conn.getUrl('cms/find_cms').subscribe((res: any) => {
      if (res.status == true) {
        this.cmsList = res.data
      }
    })
  }
}
